module.exports = __webpack_public_path__ + "img/pic2-1.ed3a1fa6.png";